export default "__VITE_ASSET__NpVbpxIx__"